<!--<div class="app-content content">
  <div class="content-overlay"></div>
  <div class="content-wrapper">
    <div class="content-header row ">
    </div>
    <div class="content-body">
      <section class="row flexbox-container">
        <div class="col-12 d-flex align-items-center justify-content-center">
          <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
            <div class="card border-grey border-lighten-3 px-2 py-2 m-0">
              <div class="card-header border-0">
                <div class="card-title text-center">-->
<!--<img src="assets/custom/images/abg/abglogo512.png" alt="branding logo">-->
<!--<label style="font-size:25px;color:deepskyblue">Reset Password</label>
</div>-->
<!--<h6 class="card-subtitle line-on-side text-muted text-center font-small-3 pt-2">
  <span>
    We will send you
    a link to reset password.
  </span>
</h6>-->
<!--</div>
<div class="card-content">
  <div class="card-body">
    <form class="form-horizontal">-->
<!--<fieldset class="form-group position-relative has-icon-left">
  <input type="password" class="form-control" id="oldpassword" placeholder="Your Old Password" required (change)="CheckOldPassword($event)">
  <div class="form-control-position">
    <i class="la la-key"></i>
  </div>
</fieldset>-->
<!--<fieldset class="form-group position-relative has-icon-left">
  <input type="password" class="form-control" id="newpassword" (change)="Password($event)" placeholder="Enter New Password"
         required>
  <div class="form-control-position">
    <i class="la la-key"></i>
  </div>
</fieldset>
<fieldset class="form-group position-relative has-icon-left">
  <input type="password" class="form-control" id="oldconfirmpassword" (change)="CheckConfirmPassword($event)" placeholder="Enter Confirmation Password"
         required>
  <div class="form-control-position">
    <i class="la la-key"></i>
  </div>
</fieldset>
<button type="submit" class="btn btn-outline-info btn-lg btn-block" (click)="ChangePassword()">
  <i class="feather ft-unlock"></i>
  Change Password
</button>
<br />-->
<!--<div class="form-group row">
  <div class="col-md-6 col-12">
    <a [routerLink]="['/gym/dashboard']" class="card-link">Go to Dashboard?</a>
  </div>
</div>-->
<!--</form>
  </div>
</div>-->
<!--<div class="card-footer border-0">
  <p class="float-sm-left text-center">-->
<!--[routerLink]="['/authentication/loginSimple']"-->
<!--<a class="card-link">Login</a>
</p>-->
<!--<p class="float-sm-right text-center">
  New to Modern ? <a [routerLink]="['/authentication/registerSimple']" class="card-link">Create Account</a>
</p>-->
<!--</div>-->
<!--</div>
          </div>
        </div>
      </section>

    </div>
  </div>
</div>-->
<!-- ═══════════════════════════════════════════════════════════════
     RESET PASSWORD — set a new password from a reset link (NEW).
     The reset token is read from the route (?token=...) in the TS.
     Shares the auth shell. Bindings match resetpassword.component.ts.
═══════════════════════════════════════════════════════════════ -->
<!--<div class="auth-shell">

  <aside class="auth-brand">
    <div class="auth-brand-logo">
      <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
      <span>KG Technologys</span>
    </div>
    <h1 class="auth-brand-headline">Set a new password.</h1>
    <p class="auth-brand-sub">Choose a strong password you haven't used before. You'll use it to sign in next time.</p>
    <ul class="auth-brand-features">
      <li><i class="la la-lock"></i> Minimum 8 characters</li>
      <li><i class="la la-shield"></i> Mix letters, numbers &amp; symbols</li>
    </ul>
    <div class="auth-brand-footer">© KG Technologys. All rights reserved.</div>
  </aside>

  <main class="auth-main">
    <div class="auth-card">
      <div class="auth-mobile-logo">
        <img src="assets/custom/images/abg/kg logo.jpeg" alt="KG Technologys" />
      </div>-->
<!-- Invalid / expired token -->
<!--<div *ngIf="tokenInvalid" style="text-align:center;">
  <div class="auth-product-icon auth-pi--gym" style="width:64px;height:64px;font-size:30px;margin:0 auto var(--space-4);">
    <i class="la la-times"></i>
  </div>
  <h2 class="auth-title">Link expired</h2>
  <p class="auth-sub">This reset link is invalid or has expired. Please request a new one.</p>
  <a [routerLink]="['/forgot-password']" class="auth-btn auth-btn-primary" style="text-decoration:none;">Request new link</a>
</div>-->
<!-- Reset form -->
<!--<form [formGroup]="resetForm" (ngSubmit)="submit()" *ngIf="!tokenInvalid && !done" novalidate>
  <h2 class="auth-title">New password</h2>
  <p class="auth-sub">Almost there — set your new password below.</p>

  <div class="auth-banner auth-banner--error" *ngIf="errorMessage">
    <i class="la la-exclamation-circle"></i> <span>{{ errorMessage }}</span>
  </div>

  <div class="auth-field">
    <label class="auth-label">New password</label>
    <div class="auth-input-wrap">
      <input [type]="showPassword ? 'text' : 'password'" class="auth-input auth-input--with-trail"
             formControlName="password" placeholder="Create a password" (input)="onPasswordChange()"
             [ngClass]="{ 'is-invalid': submitted && rf.password.errors }" />
      <i class="auth-input-icon la la-lock"></i>
      <button type="button" class="auth-input-trail" (click)="showPassword = !showPassword">
        <i class="la" [ngClass]="showPassword ? 'la-eye-slash' : 'la-eye'"></i>
      </button>
    </div>
    <div class="auth-strength" *ngIf="rf.password.value">
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 1 ? strengthClass : ''"></span>
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 2 ? strengthClass : ''"></span>
      <span class="auth-strength-bar" [ngClass]="passwordStrength >= 3 ? strengthClass : ''"></span>
    </div>
    <div class="auth-error" *ngIf="submitted && rf.password.errors?.required">Password is required</div>
    <div class="auth-error" *ngIf="submitted && rf.password.errors?.minlength">At least 8 characters</div>
  </div>

  <div class="auth-field">
    <label class="auth-label">Confirm password</label>
    <div class="auth-input-wrap">
      <input [type]="showPassword ? 'text' : 'password'" class="auth-input"
             formControlName="confirmPassword" placeholder="Re-enter password"
             [ngClass]="{ 'is-invalid': submitted && (rf.confirmPassword.errors || resetForm.errors?.mismatch) }" />
      <i class="auth-input-icon la la-lock"></i>
    </div>
    <div class="auth-error" *ngIf="submitted && resetForm.errors?.mismatch">Passwords don't match</div>
  </div>

  <button type="submit" class="auth-btn auth-btn-primary" [disabled]="loading">
    <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
    <span>{{ loading ? 'Updating…' : 'Update password' }}</span>
  </button>
</form>-->
<!-- Done state -->
<!--<div *ngIf="done" style="text-align:center;">
        <div class="auth-product-icon auth-pi--hrm" style="width:64px;height:64px;font-size:30px;margin:0 auto var(--space-4);">
          <i class="la la-check"></i>
        </div>
        <h2 class="auth-title">Password updated</h2>
        <p class="auth-sub">Your password has been changed. You can now sign in with your new password.</p>
        <a [routerLink]="['/login']" class="auth-btn auth-btn-primary" style="text-decoration:none;">Go to sign in</a>
      </div>
    </div>
  </main>
</div>-->

<div class="app-content content">
  <div class="content-wrapper">
    <section class="row flexbox-container">
      <div class="col-12 d-flex align-items-center justify-content-center">
        <div class="col-lg-4 col-md-8 col-10 box-shadow-2 p-0">
          <div class="card border-grey border-lighten-3 px-1 py-1 m-0">
            <div class="card-header border-0">
              <div class="card-title text-center">
                <h4>Set a new password</h4>
                <p class="text-muted">Your administrator requires you to set a new password before continuing.</p>
              </div>
            </div>
            <div class="card-content">
              <div class="card-body">
                <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>
                <form [formGroup]="form" (ngSubmit)="submit()">
                  <fieldset class="form-group">
                    <label for="currentPassword">Current (temporary) password</label>
                    <input type="password" id="currentPassword" formControlName="currentPassword" class="form-control"
                           [ngClass]="{ 'is-invalid': submitted && f.currentPassword.errors }">
                    <div *ngIf="submitted && f.currentPassword.errors" class="invalid-feedback">Current password is required</div>
                  </fieldset>
                  <fieldset class="form-group">
                    <label for="newPassword">New password</label>
                    <input type="password" id="newPassword" formControlName="newPassword" class="form-control"
                           [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }">
                    <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
                      Password must be at least 8 characters and include an uppercase letter, a lowercase letter, and a digit.
                    </div>
                  </fieldset>
                  <button type="submit" class="btn btn-outline-info btn-block" [disabled]="loading">
                    <i class="fa fa-refresh fa-spin" *ngIf="loading"></i> Change Password
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

